import * as React from "react";
import {
    List,
    Show,
    Edit,
    Datagrid,
    SimpleShowLayout,
    SimpleForm,
    TextField,
    EmailField,
    DateField,
    TextInput,
    DateInput,
    BooleanField,
    ArrayField,

    TabbedShowLayout,
    Tab,
    BooleanInput,

    useRecordContext,
    FunctionField,
    RichTextField,
    Create,
    FormDataConsumer,
    InfiniteList,
    EditButton,
} from 'react-admin';
import Grid from '@mui/material/Grid';
import {
    RichTextInput,
    /*
    DefaultEditorOptions,
    RichTextInputToolbar,
    LevelSelect,
    FormatButtons,
    AlignmentButtons,
    ListButtons,
    LinkButtons,
    QuoteButtons,
    ClearButtons,
    TiptapEditorContext,
    */
} from 'ra-input-rich-text';
import {
    ToggleButton,
    ToggleButtonGroup,
    ToggleButtonGroupProps,
    Alert,
} from '@mui/material';
import HorizontalRule from '@tiptap/extension-horizontal-rule';
import Remove from '@mui/icons-material/Remove';

/*
const MyRichTextInput = ({ size, ...props }) => {
    const editor = React.useContext(TiptapEditorContext);

    return (
    <RichTextInput
        editorOptions={MyEditorOptions}
        toolbar={
            <RichTextInputToolbar>
                <LevelSelect size={size} />
                <FormatButtons size={size} />
                <AlignmentButtons size={size} />
                <ListButtons size={size} />
                <LinkButtons size={size} />
                <QuoteButtons size={size} />
                <ClearButtons size={size} />
                <ToggleButton
                    aria-label="Add an horizontal rule"
                    title="Add an horizontal rule"
onClick={() => editor.chain().focus().setHorizontalRule().run()}
                    selected={editor && editor.isActive('horizontalRule')}
                >
                    <Remove fontSize="inherit" />
            </ToggleButton>
            </RichTextInputToolbar>
        }
        label="Body"
        source="body"
        {...props}
    />
)};

const MyEditorOptions = {
    ...DefaultEditorOptions,
    extensions: [
        ...DefaultEditorOptions.extensions,
        HorizontalRule,
    ],
};
*/

const listFilters = [
    <TextInput source="q" label="Search" alwaysOn />,
];

const PostPanel = () => {
    const record = useRecordContext();
    return (
        <div dangerouslySetInnerHTML={{ __html: record.message }} />
    );
};

const AnnouncementEmailNotice = () => (
    <>
        <Alert severity="warning" sx={{ mb: 2, width: '100%' }}>
            Publishing an announcement will email the entire network. Please review your message and confirm that it is correct.
        </Alert>
        <FormDataConsumer>
            {({ formData }) => {
                if(!formData.start_at) return null;
                const start = new Date(formData.start_at);
                const today = new Date();
                const isToday = start.toDateString() === today.toDateString();
                if(isToday) {
                    return <Alert severity="info" sx={{ mb: 2, width: '100%' }}>Announcements scheduled to start today will send an email immediately.</Alert>;
                }
                if(start > today) {
                    return <Alert severity="info" sx={{ mb: 2, width: '100%' }}>Announcements scheduled for a future date can be edited before the set date.</Alert>;
                }
                return null;
            }}
        </FormDataConsumer>
    </>
);

const AnnouncementList = props => (
    <InfiniteList title={"Announcements"} filters={listFilters} {...props} exporter={false} hasCreate>
        <Datagrid rowClick="show" /*expand={<PostPanel/>} isRowExpandable={()=>true}*/>

            {/* <TextField source="title" /> */}
            <FunctionField label="Announcement" render={
                record => <><b>{record.title}</b><br/><p dangerouslySetInnerHTML={{__html: record.message}}></p></>
            } />
            {/* <TextField source="message" /> */}

            <DateField source="start_at" />
            <DateField source="end_at" />

            <EditButton/>

        </Datagrid>
    </InfiniteList>
);

const AnnouncementShow = props => (
    <Show {...props}>
        <SimpleShowLayout>
            <TextField source="title" />
            <RichTextField source="message" />
            <DateField source="start_at" />
            <DateField source="end_at" />
        </SimpleShowLayout>
    </Show>
)

const AnnouncementEdit = props => (
    <Edit {...props} redirect="show" mutationMode="pessimistic">
        <SimpleForm>
            <AnnouncementEmailNotice />
            <TextInput source="title" isRequired={true} />
            {/* <MyRichTextInput source="message" /> */}
            <RichTextInput source="message" isRequired={true} />
            <DateInput source="start_at" defaultValue={''} />
            <DateInput source="end_at" defaultValue={''} />
        </SimpleForm>
    </Edit>
);

const AnnouncementCreate = props => (
    <Create {...props} redirect="show">
        <SimpleForm>
            <AnnouncementEmailNotice />
            <TextInput source="title" isRequired={true} />
            <RichTextInput source="message" isRequired={true} />
            <DateInput source="start_at" defaultValue={''} />
            <DateInput source="end_at" defaultValue={''} />
        </SimpleForm>
    </Create>
);

export {AnnouncementList, AnnouncementShow, AnnouncementEdit, AnnouncementCreate};